import { render, staticRenderFns } from "./BankAccountField.vue?vue&type=template&id=15357900"
import script from "./BankAccountField.vue?vue&type=script&lang=js"
export * from "./BankAccountField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports